import React, { Component } from 'react';
import { Link } from 'gatsby';
import Flickity from './Flickity';
import classNames from 'classnames';
import createTaxonomyLink from '../utils/createTaxonomyLink';
import { connectToStore } from './Provider';

const SLIDE_OPTIONS = {
	cellAlign: 'center',
	contain: true,
	wrapAround: true,
	pageDots: false,
	prevNextButtons: false,
	selectedAttraction: 0.1,
	friction: 0.8,
	autoPlay: 3000,
};

class FeaturedBrandLogosCarousel extends Component {
	constructor() {
		super();

		this.state = { activeBrandIndex: 0 };
	}

	setSliderRef = slider => {
		this.logoSlider = slider;

		// Add change event to keep track of index
		this.logoSlider.on('change', () => {
			this.setState({ activeBrandIndex: this.logoSlider.selectedIndex });
		});
	}

	render() {
		const {
			title,
			shopAllLink,
			brands,
			openVideoModal,
		} = this.props;

		const { activeBrandIndex } = this.state;

		let shopAllLinkButton;

		const logoCarousel = (
			<Flickity
				sliderRef={this.setSliderRef}
				className="brand-carousel"
				key="logo-carousel"
				options={SLIDE_OPTIONS}>{[...brands, ...brands,].map((brand, index) => {
					if (!brand.brandLink) {
						return (
							<span
								key={`${index}_${brand._key}`}
								className={classNames('brand-carousel__logo mr2 mr5--md', {
									active: index === activeBrandIndex
								})}>
								<img
									className="db contained-width"
									alt={brand.title}
									src={brand.logo}
								/>
							</span>
						);
					}

					if (brand.brandLink._type === 'link') {
						if (brand.brandLink.url[0] === '/') {
							return (
								<Link
									key={`${index}_${brand._key}`}
									to={brand.brandLink.url}
									title={brand.brandLink.title}
									className={classNames('brand-carousel__logo mr2 mr5--md', {
										active: index === activeBrandIndex
									})}>
									<img
										className="db contained-width"
										alt={brand.title}
										src={brand.logo}
									/>
								</Link>
							);
						} else {
							return (
								<a
									key={`${index}_${brand._key}`}
									href={brand.brandLink.url}
									title={brand.brandLink.title}
									className={classNames('brand-carousel__logo mr2 mr5--md', {
										active: index === activeBrandIndex
									})}>
									<img
										className="db contained-width"
										alt={brand.title}
										src={brand.logo}
									/>
								</a>
							);
						}
					} else if (brand.brandLink._type === 'videoModalLink') {
						return (
							<button
								key={`${index}_${brand._key}`}
								to={brand.brandLink.url}
								title={brand.brandLink.title}
								className={classNames('brand-carousel__logo mr2 mr5--md', {
									active: index === activeBrandIndex
								})}
								onClick={() => openVideoModal(shopAllLink.videoId)}>
								<img
									className="db contained-width"
									alt={brand.title}
									src={brand.logo}
								/>
							</button>
						);
					} else if (brand.brandLink._type === 'taxonomyLink') {
						return (
							<Link
								key={`${index}_${brand._key}`}
								to={createTaxonomyLink(brand.brandLink.taxonomies)}
								title={brand.brandLink.title}
								className={classNames('brand-carousel__logo mr2 mr5--md', {
									active: index === activeBrandIndex
								})}>
								<img
									className="db contained-width"
									alt={brand.title}
									src={brand.logo}
								/>
							</Link>
						);
					}
				})}</Flickity>
		);

		if (shopAllLink._type === 'link') {
			if (shopAllLink.url[0] === '/') {
				shopAllLinkButton = (
					<Link
						className="button--secondary full-width"
						title={shopAllLink.title}
						to={shopAllLink.url}>
						{shopAllLink.title}
					</Link>
				);
			} else {
				shopAllLinkButton = (
					<a
						className="button--secondary full-width"
						title={shopAllLink.title}
						href={shopAllLink.url}>
						{shopAllLink.title}
					</a>
				);
			}
		} else if (shopAllLink._type === 'videoModalLink') {
			shopAllLinkButton = (
				<button
					title={shopAllLink.title}
					className="button--secondary full-width"
					onClick={() => openVideoModal(shopAllLink.videoId)}
					name="video">
					{shopAllLink.title}
				</button>
			);
		} else if (shopAllLink._type === 'taxonomyLink') {
			shopAllLinkButton = (
				<Link
					className="button--secondary full-width"
					title={shopAllLink.title}
					to={createTaxonomyLink(shopAllLink.taxonomies)}>
					{shopAllLink.title}
				</Link>
			);
		}

		const header = (
			<div className="media media--horizontal media--reverse gutter--small align--middle pb3 pb4--md">
				<div className="media__fluid">
					<h2 className="uppercase fw--600">
						{title}
					</h2>
				</div>
				<div className="media__fixed show--md">
					{shopAllLinkButton}
				</div>
			</div>
		);


		return (
			<div className="of--hidden grid-container contained mt10 mb10">
				{header}
				{logoCarousel}
			</div>
		);
	}
}

const mapStateToProps = () => ({});

const mapStoreToProps = ({
	openVideoModal,
}) => ({
	openVideoModal,
});

export default connectToStore(mapStateToProps, mapStoreToProps)(FeaturedBrandLogosCarousel);